import * as React from 'react'

export const useToggle = (initialState = false) => {
  const [open, setOpen] = React.useState(initialState)
  
  const toggle = () => setOpen(!open)
  
  return { open, toggle }
}
